function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.547 117.11H26.328C25.1225 117.11 24.1455 116.133 24.1455 114.927C24.1455 113.722 25.1225 112.745 26.328 112.745H89.547C90.7525 112.745 91.7295 113.722 91.7295 114.927C91.7295 116.133 90.7525 117.11 89.547 117.11Z",
  fill: "#6EE7B7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M91.3125 81.765H24.5625C23.872 81.765 23.3125 81.2055 23.3125 80.515C23.3125 79.8245 23.872 79.265 24.5625 79.265H91.3125C92.003 79.265 92.5625 79.8245 92.5625 80.515C92.5625 81.2055 92.003 81.765 91.3125 81.765Z",
  fill: "#6EE7B7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.969 86.765H16.4375C15.747 86.765 15.1875 86.2055 15.1875 85.515C15.1875 84.8245 15.747 84.265 16.4375 84.265H74.969C75.6595 84.265 76.219 84.8245 76.219 85.515C76.219 86.2055 75.659 86.765 74.969 86.765Z",
  fill: "#6EE7B7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99.4375 86.765H80.271C79.5805 86.765 79.021 86.2055 79.021 85.515C79.021 84.8245 79.5805 84.265 80.271 84.265H99.4375C100.128 84.265 100.687 84.8245 100.687 85.515C100.687 86.2055 100.128 86.765 99.4375 86.765Z",
  fill: "#6EE7B7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M103.062 25.64C105.824 25.64 108.062 23.4014 108.062 20.64C108.062 17.8786 105.824 15.64 103.062 15.64C100.301 15.64 98.0625 17.8786 98.0625 20.64C98.0625 23.4014 100.301 25.64 103.062 25.64Z",
  fill: "#F472B6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.3745 71.765H29.771C29.2185 71.765 28.771 71.3175 28.771 70.765V40.9315C28.771 40.379 29.2185 39.9315 29.771 39.9315H44.3745C44.9265 39.9315 45.3745 40.379 45.3745 40.9315V70.765C45.3745 71.317 44.927 71.765 44.3745 71.765Z",
  fill: "#6EE7B7"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 56,
  r: 6,
  fill: "#111827"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 56,
  r: 4,
  fill: "#6EE7B7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2395 71.765H50.636C50.0835 71.765 49.636 71.3175 49.636 70.765V40.9315C49.636 40.379 50.0835 39.9315 50.636 39.9315H65.2395C65.792 39.9315 66.2395 40.379 66.2395 40.9315V70.765C66.2395 71.317 65.7915 71.765 65.2395 71.765Z",
  fill: "#6EE7B7"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 56,
  r: 6,
  fill: "#111827"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 56,
  r: 4,
  fill: "#6EE7B7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M86.104 71.765H71.5005C70.948 71.765 70.5005 71.3175 70.5005 70.765V40.9315C70.5005 40.379 70.948 39.9315 71.5005 39.9315H86.104C86.6565 39.9315 87.104 40.379 87.104 40.9315V70.765C87.104 71.317 86.6565 71.765 86.104 71.765Z",
  fill: "#6EE7B7"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 56,
  r: 6,
  fill: "#111827"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 56,
  r: 4,
  fill: "#6EE7B7"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M107.312 46.39H106.562V29.7295C110.213 28.319 112.812 24.7815 112.812 20.64C112.812 15.264 108.438 10.89 103.062 10.89C97.6865 10.89 93.3125 15.264 93.3125 20.64C93.3125 24.7815 95.9125 28.319 99.5625 29.7295V46.39H92.5625V36.39C92.5625 35.6995 92.003 35.14 91.3125 35.14H24.5625C23.872 35.14 23.3125 35.6995 23.3125 36.39V46.39H20.0625C17.9945 46.39 16.3125 48.072 16.3125 50.14V62.39C16.3125 64.458 17.9945 66.14 20.0625 66.14H23.3125V76.14C23.3125 76.8305 23.872 77.39 24.5625 77.39H91.3125C92.003 77.39 92.5625 76.8305 92.5625 76.14V66.14H107.312C109.381 66.14 111.062 64.458 111.062 62.39V50.14C111.062 48.072 109.381 46.39 107.312 46.39ZM95.8125 20.64C95.8125 16.6425 99.065 13.39 103.062 13.39C107.06 13.39 110.312 16.6425 110.312 20.64C110.312 24.6375 107.06 27.89 103.062 27.89C99.065 27.89 95.8125 24.6375 95.8125 20.64ZM102.062 30.3385C102.392 30.372 102.725 30.3895 103.062 30.3895C103.4 30.3895 103.733 30.372 104.062 30.3385V46.39H102.062V30.3385ZM20.0625 63.64C19.373 63.64 18.8125 63.0795 18.8125 62.39V50.14C18.8125 49.451 19.373 48.89 20.0625 48.89H23.3125V63.64H20.0625ZM90.0625 74.89H25.8125V64.89V47.64V37.64H90.0625V47.64V64.89V74.89ZM108.562 62.39C108.562 63.0795 108.002 63.64 107.312 63.64H92.5625V48.89H100.812H105.312H107.312C108.002 48.89 108.562 49.451 108.562 50.14V62.39Z",
  fill: "#4F46E5"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M100.093 84.45L91.968 79.45C91.38 79.0895 90.61 79.2715 90.2485 79.8595C89.8865 80.4475 90.07 81.2175 90.6575 81.579L98.188 86.213V104.681H17.688V86.213L25.2185 81.579C25.8065 81.2175 25.9895 80.4475 25.6275 79.8595C25.266 79.2715 24.4965 79.0895 23.908 79.45L15.783 84.45C15.4135 84.6775 15.188 85.0805 15.188 85.5145V105.931C15.188 106.622 15.7475 107.181 16.438 107.181H99.438C100.128 107.181 100.688 106.622 100.688 105.931V85.515C100.687 85.081 100.462 84.6775 100.093 84.45Z",
  fill: "#4F46E5"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3386 100.682C79.0291 100.682 79.5886 100.122 79.5886 99.4315V90.598C79.5886 89.9075 79.0291 89.348 78.3386 89.348H37.5366C36.8461 89.348 36.2866 89.9075 36.2866 90.598V99.4315C36.2866 100.122 36.8461 100.682 37.5366 100.682H78.3386ZM38.7866 91.848H77.0886V98.1815H38.7866V91.848Z",
  fill: "#4F46E5"
});

function SvgAfterRegisterImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterRegisterImage);
export default __webpack_public_path__ + "static/media/afterRegisterImage.758f12dcd50b4d216fabceee21a77a04.svg";
export { ForwardRef as ReactComponent };